import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { proxPaymentEnd, proxPaymentStart } from 'redux/payment/paymentSlice'
import { OriginalRootState } from 'redux/rootReducer'
import { InvoiceSummary } from 'typings/invoiceSummary'
import { UnpaidInvoiceState } from 'typings/reduxStore'

export const initState: UnpaidInvoiceState = {
  status: 'initial',
  dataList: [],
  invoiceCount: 0,
  isDataLoading: true,
  isInvoiceResponseFail: false,
  invoiceErrorMessage: '',
  isSelectedAll: false,
  selectedItems: [],
  gridOption: {
    limit: 20,
    currentPage: 1,
    invoiceCount: 0,
    accountNumber: '',
    accessToken: ''
  },
  filterOption: { value: 'transactionId', label: 'Invoice NO' },
  recordLimitOption: { value: '', label: '' },
  transactionDetail: {} as InvoiceSummary,
  isTransactionResponseFail: false,
  transactionErrorMessage: '',
  resetSelectedItems: true,
  isDetailDataLoading: true,
  prevPaymentTotal: 0,
  printInvoiceList: [],
  isPrintInvoiceLoading: true,
  poNumberError: ''
}

const invoiceSlice = createSlice({
  name: 'invoiceSlice',
  initialState: initState,
  reducers: {
    updateInvoiceState: (
      state: UnpaidInvoiceState,
      action: PayloadAction<UnpaidInvoiceState>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    },
    removeSelectedCredits: state => {
      state.selectedItems = state.selectedItems.filter(
        item => item.transactionClass !== 'CM'
      )
    }
  },
  extraReducers: builder => {
    builder
      /**
       * Caution: on local StrictMode component will render twice on mount
       * setting resetSelectedItems to true when page finish loading. It' doesn't happen on DEV / QA
       */
      .addCase(proxPaymentStart, state => {
        // clear selected items when payments page opens except when invoked using "pay invoice" button
        if (state.resetSelectedItems) {
          state.selectedItems = []
          state.prevPaymentTotal = 0
        }
      })
      .addCase(proxPaymentEnd, state => {
        state.resetSelectedItems = true
        state.selectedItems = []
        state.prevPaymentTotal = 0
      })
  }
})

export const { updateInvoiceState, removeSelectedCredits } =
  invoiceSlice.actions

export const selectUnpaidInvoices = (state: OriginalRootState) =>
  state.invoiceSummary.dataList || []

export const selectInvoiceCount = (state: OriginalRootState) =>
  state.invoiceSummary.invoiceCount

export const selectIsInvoicesDataLoading = (state: OriginalRootState) =>
  state.invoiceSummary.isDataLoading

export const selectUnpaidSelectedInvoices = (state: OriginalRootState) =>
  state.invoiceSummary.selectedItems || []

export default invoiceSlice.reducer
